import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@material-ui/core";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import clsx from "clsx";
import moment from "moment";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";

import { default as Apiservices } from "../../../common";
import useStyles from "../../../themes/makeStyles";
import FilterForm from "./filterForm";
import tableDataHeader from "../../../constants/TableDataConstants";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(0),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
            <KeyboardArrowLeft />
          )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
            <KeyboardArrowRight />
          )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles({
  table: {
    minWidth: "100%",
    whiteSpace: "nowrap",
    td: {},
  },
  toobarBgColor: {
    "& .MuiToolbar-regular": {
      background: "#fff",
    },
  },
  container: {
    maxHeight: "60vh",
    minHeight: "100px",
    overflowY: "hidden",
    "&:hover": {
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "4px",
      },

      /* Track */

      "&::-webkit-scrollbar-track": {
        background: "#fff",
      },

      /* Handle */

      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#d4d8da",
        borderRadius: "20px",
      },

      /* Handle on hover */

      "&::-webkit-scrollbar-thumb:hover": {
        background: "",
      },
    },
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

export default function InvoiceReport() {
  const InvoiceTableHeaderDetails = tableDataHeader.INVOICE_REPORT_TABLE_HEADER;
  const invoiceTabelDataKeys = tableDataHeader.INVOICE_REPORT_TABLE_KEYS;
  const classesTwo = useStyles();
  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [array, setArray] = React.useState([
    { invoicedate: "No Data", count: "No Data" },
  ]);
  const [loading, setLoading] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [resetvalues, setResetvalues] = React.useState(true);
  const [saveFilterData, setSaveFilterData] = React.useState();
  const [disableSftoButton, setDisableSftoButton] = React.useState(true);
  const [showFilterFlag, setShowFilterFlag] = useState(false);
  const [expandedPanel, setExpandedPanel] = useState({
    panel1: true,
    panel2: true,
  });

  const fetchData = async (data) => {
    let response;
    if (data) {
      if (data.schemetype === "SFTO") {
        response = await Apiservices.getInvoiceSftoDeatilsReport(data);
      } else {
        response = await Apiservices.getInvoiceGpwisDeatilsReport(data);
      }
    } else {
      response = await Apiservices.getInvoiceSftoDeatilsReport();
    }
    if (response && response.Records.length > 0) {
      setArray(
        response.Records && response.Records.length > 0
          ? response.Records
          : []
      );
    } else {
      setArray([]);
      console.log("Server not working");
    }
    console.log(response, "apiresp");
  };

  const handleAccordionChange = (panel, expandedPanel) => (
    event,
    isExpanded
  ) => {
    let expansionPanelList = {};
    expansionPanelList = expandedPanel;

    expansionPanelList[panel] = expansionPanelList[panel] ? false : true;
    setExpandedPanel({
      panel1:
        panel === "panel1"
          ? expansionPanelList[panel]
          : expansionPanelList["panel1"],
      panel2:
        panel === "panel2"
          ? expansionPanelList[panel]
          : expansionPanelList["panel2"],
    });
  };

  useEffect(() => {
    const response = fetchData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    let params = {};
    params.limit = newPage - 1;
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getFilterData = (values) => {
    setSaveFilterData(values);
    fetchData(values);
  };

  const handleClear = () => {
    setSaveFilterData(null);
    fetchData();
  };

  const checkIfvalueIsDate = (value) => {
    if (typeof value === "string") {
      return value.includes("T") && value.includes("-");
    } else {
      return false;
    }
  };


  return (
    <>
      <div>
        <Box py={3}>
          <Grid container spacing={2} justify="space-between" alignItems="center">
            <Grid item>
              <h2 className={classesTwo.mainHeading}>{"Invoice Report"}</h2>
            </Grid>
          </Grid>
        </Box>

        {/* filters start */}
        <Box py={1}>
          <form id="list-job" key={resetvalues}>
            {showFilterFlag ? (
              <div />
            ) : (
                <Box py={1}>
                  <Paper elevation={0}>
                    <Accordion
                      expanded={expandedPanel["panel1"] === true}
                      onChange={handleAccordionChange("panel1", expandedPanel)}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography className={classes.secondHeading}>
                          Filter By
                    </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Box width={"100%"}>
                          <FilterForm
                            getFilterData={getFilterData}
                            handleClear={handleClear}
                          />
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  </Paper>
                </Box>
              )}
          </form>
        </Box>
        {/* filters end */}

        <div>
          <Box py={1}>
            <TableContainer
              component={Paper}
              className={clsx("freezeTable", classes.container)}
            >
              <Table
                // className={clsx('freezeTable')}
                aria-label="simple table"
                stickyHeader
              >
                {loading ? (
                  <></>
                ) : (
                    <>
                      <TableHead>
                        <TableRow>
                          {InvoiceTableHeaderDetails &&
                            InvoiceTableHeaderDetails.map((item, index) => {
                              return (
                                <StyledTableCell
                                  key={index}
                                  align={item === "Job Id" ? "Left" : "center"}
                                  style={{
                                    minWidth: item === "Job Id" ? 210 : "",
                                    maxWidth: item === "Job Id" ? 220 : "",
                                  }}
                                >
                                  <b>{item} </b>
                                </StyledTableCell>
                              );
                            })}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(rowsPerPage > 0
                          ? array?.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          : array
                        ).map((row, index) => (
                          <TableRow key={index}>
                            {invoiceTabelDataKeys &&
                              invoiceTabelDataKeys.map((item, colIndex) => {
                                return (
                                  <TableCell
                                    key={colIndex}
                                    align={item === "job_id" ? "Left" : "center"}
                                    style={{
                                      minWidth: item === "job_id" ? 200 : "",
                                      maxWidth: item === "job_id" ? 200 : "",
                                    }}
                                  >
                                    {row[item] ? (
                                      checkIfvalueIsDate(row[item]) ? (
                                        <b>
                                          {moment(row[item]).format("DD-MM-YYYY")}
                                        </b>
                                      ) : (
                                          <b>{row[item]}</b>
                                        )
                                    ) : (
                                        <b>-</b>
                                      )}
                                  </TableCell>
                                );
                              })}
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter>
                        <TableRow></TableRow>
                      </TableFooter>
                    </>
                  )}
              </Table>
            </TableContainer>
            <TableContainer>
              <TablePagination
                className={classes.toobarBgColor}
                rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                component="div"
                count={array && array.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                  native: true,
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableContainer>
          </Box>
        </div>
      </div>
    </>);
}
